import { useEffect, useState } from "react";
import { CommonService } from "../services/CommonService";

export interface ILatLngPoint {
  lat: number;
  lng: number;
}

/**
 * Polígono cacheado en backend que aproxima el perímetro real (manejando,
 * no línea recta) del radio de envío gratis para una sucursal — generado
 * por `php artisan warehouse:generate-free-shipping-perimeter`. Si todavía
 * no se generó (points vacío), el consumidor debe caer a un <Circle> recto.
 */
export const useFreeShippingPerimeter = (warehouseId?: number) => {
  const [points, setPoints] = useState<ILatLngPoint[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!warehouseId) {
      setPoints([]);
      return;
    }
    setLoading(true);
    CommonService.getWarehouseFreeShippingPerimeter(warehouseId)
      .then((res) => {
        setPoints(res.object?.points ?? []);
      })
      .catch((err) => {
        console.error("No se pudo cargar el perímetro de envío gratis", err);
        setPoints([]);
      })
      .finally(() => setLoading(false));
  }, [warehouseId]);

  return { points, loading };
};
